export { default } from './DetailDataGrid';
